import { Tooltip } from 'react-tooltip';

// @todo: should be revisited as per https://code.roche.com/gps/ces/ces-application/-/issues/1744
const TooltipWrapper = ({ children, ...props }: React.ComponentProps<typeof Tooltip>) => {
  return <Tooltip {...props}>{children}</Tooltip>;
};

export default TooltipWrapper;
